module.exports = __webpack_public_path__ + "static/media/bay2022FeaturesBanner_Tablet_738x57px_@1x.e5d880da.jpg";